// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"e992138a","224":"5ae6522a","433":"1ded680b","891":"5ae6522a","950":"2f2bd413"}[chunkId] + ".chunk.css";
};